import { call, put, takeLatest } from "redux-saga/effects";
// Login Redux States
import { GET_ROLEPERMISSION, EDIT_ROLEPERMISSION } from "./actionTypes";
import {
  getRolePermission,
  editRolePermission,
} from "../../http/fundLync/role.helper";
import { allRolePermissions } from "../actions";

function* getRolePermissions({ payload: { role } }) {
  try {
    const responseFromAPI = yield call(getRolePermission, role);
    if (responseFromAPI.code == 200) {
      const { data } = responseFromAPI;
      yield put(allRolePermissions({ data }));
    }
  } catch (error) {
    console.error("error", error);
  }
}

function* editRolePermissions({ payload: { rolePermission } }) {
  try {
    const responseFromAPI = yield call(editRolePermission, rolePermission);
    if (responseFromAPI.code == 201) {
      console.log(responseFromAPI);
    }
  } catch (error) {
    console.log("error", error);
  }
}

function* rolePermissionSaga() {
  yield takeLatest(GET_ROLEPERMISSION, getRolePermissions);
  yield takeLatest(EDIT_ROLEPERMISSION, editRolePermissions);
}

export default rolePermissionSaga;
